import type { Incident } from '../types/incident.types'
import { IncidentRow } from './IncidentRow'

interface ListViewProps {
  incidents: Incident[]
  onSelect?: (id: number) => void
}

const COLUMNS: string[] = [
  'ID',
  'Title',
  'Priority',
  'Status',
  'Assignee',
  'Created',
]

export function ListView({ incidents, onSelect }: ListViewProps): JSX.Element {
  return (
    <div className="overflow-x-auto rounded-lg border border-gray-200 bg-white">
      <table className="w-full min-w-max border-collapse">
        <thead className="sticky top-0 z-10 bg-gray-50">
          <tr>
            {COLUMNS.map((col) => (
              <th
                key={col}
                className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-gray-500"
              >
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {incidents.map((incident) => (
            <IncidentRow key={incident.id} incident={incident} onSelect={onSelect} />
          ))}
        </tbody>
      </table>
    </div>
  )
}
